export const CLOUD_API_FEATURE_KEY = "cloudApi";
export const QR_SESSIONS_FEATURE_KEY = "qrSessions";

const FEATURE_FALLBACKS = {
  [QR_SESSIONS_FEATURE_KEY]: ["whatsappConnection"],
};

export function getFeatureUsage(subscription, featureKey) {
  const usageByKey = subscription?.usageByKey || {};
  if (usageByKey[featureKey]) return usageByKey[featureKey];

  for (const fallbackKey of FEATURE_FALLBACKS[featureKey] || []) {
    if (usageByKey[fallbackKey]) return usageByKey[fallbackKey];
  }
  return null;
}

export function isFeatureAvailable(subscription, featureKey, role) {
  if (role === "admin") return true;
  const usage = getFeatureUsage(subscription, featureKey);
  return !!usage && (usage.total > 0 || usage.total === -1);
}
